import { render } from "./ClientRepairVideos.vue?vue&type=template&id=359d035b&scoped=true&ts=true"
import script from "./clientRepairVideosHelper.ts?vue&type=script&lang=ts"
export * from "./clientRepairVideosHelper.ts?vue&type=script&lang=ts"

import "./ClientRepairVideos.vue?vue&type=style&index=0&id=359d035b&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-359d035b"]])

export default __exports__